module.exports = __webpack_public_path__ + "img/5-1_07.81985d34.jpg";